<template>
  <div>
    <SGPPageHeaderComponent
      titulo="Backlog Tarefas"
      :mostrarBusca="false"
      :mostrarBotaoFiltroAvancado="true"
      @emitAbrirFiltro="abrirFiltro"
      class="pb-8"
    />

    <SGPFiltroAvancadoComponent 
      :abrirFiltroAvancado="abrirFiltroAvancado"
      :formSeletores="formSeletores"
      :filtroCec="true"
      @sgpFormFilterDadosClick="aplicarFiltro"
      @mudancaStatusEmit="mudancaStatusFiltro"
      @limparDadosEmit="limparDadosFiltro"
    />

    <v-tabs            
      flat
      background-color="transparent"
      v-model="tabs"
      class="mt-4"
      @change="handleMudancaTab"
    >
      <v-tab>Ativação</v-tab>
      <v-tab>Desativação</v-tab>
    </v-tabs>

    <v-tabs-items
        v-model="tabs"
        background-color="transparent"
        class="painel-produzidos-tabs"
        style="background: transparent;"
    >
      <v-tab-item style="background: transparent;" class="pt-5">
        <span v-if="!loadingBacklog">
          <TabelaBacklogTarefaExecucaoComponent 
          @detalharTarefasEmit="detalharTarefasSelecao"
          :dados="listaDeBacklogMacroprocessos.em_execucao" />

          <TabelaBacklogTarefaInterrupcaoComponent 
          @detalharTarefasEmit="detalharTarefasSelecao"
          :dados="listaDeBacklogMacroprocessos.interrompido"
          v-if="listaDeBacklogMacroprocessos.interrompido"
          />
        </span>
      </v-tab-item>

      <v-tab-item style="background: transparent;" class="pt-5">
        <span v-if="!loadingBacklog">
          <TabelaBacklogTarefaExecucaoComponent 
          @detalharTarefasEmit="detalharTarefasSelecao"
          :dados="listaDeBacklogMacroprocessos.em_execucao" />

          <TabelaBacklogTarefaInterrupcaoComponent 
          @detalharTarefasEmit="detalharTarefasSelecao"
          :dados="listaDeBacklogMacroprocessos.interrompido"
          v-if="listaDeBacklogMacroprocessos.interrompido"
          />
        </span>
      </v-tab-item>
    </v-tabs-items>

    <DetalheTarefasComponent 
        v-if="exibirDetalheTarefas"
        class="mt-15"
        :filtrosTarefas="filtrosTarefas"
        :key="keyDetalheTarefas"
     />
    <SGPLoadingComponent v-if="loadingBacklog" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import TabelaBacklogTarefaExecucaoComponent from '../components/TabelaBacklogTarefaExecucaoComponent.vue'
import TabelaBacklogTarefaInterrupcaoComponent from '../components/TabelaBacklogTarefaInterrupcaoComponent.vue'
import DetalheTarefasComponent from '../components/DetalheTarefasComponent.vue'
import { getParametrosVaziosFiltrosTarefas, getRegionaisDoUsuario } from '@/common/helpers/FiltroAvancado.js'

export default {
  name: 'BacklogTarefaPage',
  components: { 
    TabelaBacklogTarefaExecucaoComponent,
    TabelaBacklogTarefaInterrupcaoComponent,
    DetalheTarefasComponent
  },
  data () {
    return { 
      formSeletores: {
        projeto_migracao: '',
        disponibilizados: '',
        desativacao: 0
      },
      filtroPayload: {},
      filtrosTarefas: getParametrosVaziosFiltrosTarefas(),
      keyDetalheTarefas: 0,
      exibirDetalheTarefas:false,
      abrirFiltroAvancado: false,
      tabs: 0,
    }
  },

  mounted () {    
    this.setParametrosFiltroPayload();
    this.obterResumoHeaderBacklog(this.filtroPayload);
  },

  computed: {
    ...mapGetters('backlog', [
      'listaDeBacklogMacroprocessos',
      'loadingBacklog',
    ]),
  },
  
  methods: {
    ...mapActions('backlog',[
      'obterResumoHeaderBacklog',
    ]),

    limparDadosFiltro (){
      this.formSeletores.projeto_migracao = ''
      this.formSeletores.disponibilizados = false
      this.getParamFiltro()
    },

    getParamFiltro () {
      if(localStorage.filtroAvancado) {    
          this.filtroPayload = JSON.parse(localStorage.filtroAvancado)
        } else {
          const payload = {          
          ...this.formSeletores,        
          }           
          this.filtroPayload = payload          
        }
    },

    setParametrosFiltroPayload (){
        this.filtroPayload = {
          ...this.formSeletores,
          ...this.filtroPayload,
          desativacao: this.tabs,
          ...{
            ctrl_regional_id: getRegionaisDoUsuario(),
          }
        }
    },

    mudancaStatusFiltro (val) {
      this.abrirFiltroAvancado = val;
    },

    abrirFiltro () {
      this.abrirFiltroAvancado = true;
    },
    
    async aplicarFiltro (dados) {
      let filtroLateralPayload = {
        ...dados,
        ...this.formSeletores,
        ...{ 'ctrl_processo_id' : this.filtroPayload.ctrl_processo_id ? this.filtroPayload.ctrl_processo_id : '' },
      } 

      this.filtroPayload = filtroLateralPayload

      this.obterResumoHeaderBacklog(this.filtroPayload)

      this.abrirFiltroAvancado = false
      this.exibirDetalheTarefas = false
      this.abrirFiltroAvancado = false
    },

    detalharTarefasSelecao (obj){
      if(typeof obj.event == 'undefined'){
        return false;
      }
      this.setParametrosFiltrosTarefas(obj.ctrlTarefa,obj.aging,obj.ctrlMacroProcessoId,obj.ctrlFamiliaId,obj.interrupcoes);
      this.keyDetalheTarefas += 1; 
      this.exibirDetalheTarefas = true;
      this.abrirFiltroAvancado = false;
    },

    setParametrosFiltrosTarefas (ctrlTarefa,aging,ctrlMacroProcessoId,ctrlFamiliaId,interrupcoes) {
      this.filtroPayload.interrupcoes = interrupcoes;
      this.filtrosTarefas = {
        item: { 
          ctrlMacroProcessoId: ctrlMacroProcessoId,
          ctrlTarefaId: ctrlTarefa,
          aging: aging,
          ctrlFamiliaId: ctrlFamiliaId,
          emAtendimento: 1,
          flagInterrupcao: interrupcoes,
          desativacao: this.formSeletores.desativacao
        },
        ...this.filtroPayload
      };
    },
  },

  watch: {
    tabs (val) {
      this.formSeletores.desativacao = val
      this.setParametrosFiltroPayload();
      this.obterResumoHeaderBacklog(this.filtroPayload);
    }
  }
}
</script>
<style>
.dados-aging{
    font-size: 12px;
  }

.fundo-tabela{
  background-color: #eeeeee;
} 

.fundo-primeira-coluna {
  background-color: #DBDBDB!important;
  color: black;
  font-weight: bold;
} 

.borda-primeirac {
  border-top: 2px solid #ffffff!important;
  border-bottom: 2px solid #ffffff!important;
}

.titulo {
  font-size: 13px;
}

.titulo-tabela-interrompido {
  color:#DA291C;
  text-align: left!important;;
  size: 16px !important;
  padding-left: 10px!important;
}

.titulo-tabela {
  color:#B41E13;
  text-align: left!important;;
  size: 16px !important;
  padding-left: 10px!important;
}

.titulo td,
.titulo th,
.dados-aging td,
.dados-aging th  {
  border: 1px solid #D9D9D9;
}

.titulo td,
.dados-aging td {
  white-space: nowrap;
  text-align: center;
  width: 90px;
}

.titulo th,
.dados-aging th {
  padding: 2px;
  text-align: center;
}

.vertical-text {
    writing-mode: vertical-rl;
    text-align: right;
    margin: 0 auto;
  }

.borda-macroprocesso {
  border-right: 1px solid black!important;
}

.bg-vencido {
  background-color: #FFBDBD!important;
}

.bg-coluna-total, .bg-coluna-total-geral {
  background-color: #9f9f9f!important;
  color: #fff !important;
}

.bg-coluna-total-geral {
  background-color: #555!important;
}
</style>